import React from 'react';
import SkeletonTableLoader from './SkeletonTableLoader';

const Table = ({ headers, rows, loading }) => {
  return (
    <div className="overflow-hidden rounded-xl border border-slate-200">
      <table className="w-full text-sm">
        <thead>
          <tr className="bg-slate-50 text-left">
            {headers.map((header, index) => (
              <th
                key={index}
                className="px-4 py-3 font-medium uppercase tracking-wide text-xs text-slate-500 whitespace-nowrap"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        {loading ? (
          <SkeletonTableLoader numCols={headers.length} />
        ) : (
          <tbody className="divide-y divide-slate-100">
            {rows.map((row, index) => (
              <tr
                key={index}
                className="bg-white transition-colors duration-150 hover:bg-slate-50"
              >
                {row.map((cell, j) => (
                  <td key={j} className="px-4 py-3 text-slate-700">
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        )}
      </table>
    </div>
  );
};

export default Table;
